export default __webpack_public_path__ + "static/media/parc4.233b4a2e.png";